<template>
  <v-sheet color="#f5f5f5" min-height="100%">
    <v-container v-if="item.title" class="py-10 py-md-13 py-lg-16">
      <TitleWidget>
        {{ item.title }}
      </TitleWidget>

      <v-row justify="center">
        <v-col cols="12" md="9">
          <img
            class="d-block mt-6 mt-md-8"
            :src="files + item.img + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
            :alt="item.title"
            width="100%"
          />

          <div
            v-if="item.text"
            class="text-subtitle-1 mt-8 ck-content item-text"
            v-html="item.text"
          ></div>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
import TitleWidget from "../components/widgets/TitleWidget.vue";

const _config = {
  mod: "articles",
};

export default {
  created() {
    this.getItem();
  },
  computed: {
    itemId() {
      return this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1");
    },
    item() {
      return this.$rest(_config.mod).item;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    getItem() {
      this.$rest(_config.mod)
        .get({ id: this.itemId })
        .catch(() => this.$router.replace("/error404"));
    },
  },
  watch: {
    itemId() {
      this.getItem();
    },
  },
  components: {
    TitleWidget,
  },
};
</script>
